import React,{ useEffect, useState } from 'react';
import { Box, Button, TableContainer ,IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from "@mui/material"
import theme from "../../utils/theme";
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import StyledTableData from "../utils/StyledTableData";
import StyledTableHead from "../utils/StyledTableHead";
import SearchInput from "../main/filter-components/SearchInput";
import AppPagination from "../main/filter-components/AppPagination";
import CreateNewStock from '../item_list_components/CreateNewStock'
import AddStock from "./UpdateStock";
import { useDispatch, useSelector } from "react-redux";
import { getAllItem, itemCud } from "../../slices/itemSlice";
import NoDataAlert from '../utils/NoDataAlert';
import { useLocation } from 'react-router-dom';
import Loading from '../utils/Loading'
import AlertDialog from '../utils/AlertDialog';
import UpdateItem from './UpdateItem';
import InventoryIcon from '@mui/icons-material/Inventory';
import TransferStock from './TransferStock';

const StockList = () => {
    const dispatch = useDispatch()
    const [ showAlert,setShowAlert ] = useState(false)
    const [ idToDel,setIdToDel ] = useState(null)
    const { search } = useLocation();
    const { items: stockList, loading } = useSelector(state=> state.Item)
    const [ itemData, setItemData ] = React.useState(null)
    const [open, setOpen] = React.useState(false);
    const [ editOpen, setEditOpen] = React.useState(false);
    const [openAddStock, setOpenAddStock] = React.useState(false);
    const [ idToAdd,setIdToAdd ] = React.useState(null)
    const [ transferOpen,setTransferOpen ] = useState(false)
    
    const fetchData = async()=>{
        await dispatch(getAllItem({ method: 'get', data: null, keyword: null }))
    }

    const handleDelete = async (id)=>{
        setShowAlert(true)
        setIdToDel(id)
    }

    const handleCancel = ()=>{
        setShowAlert(false)
        setIdToDel(null)
    }
    
    const handleConfirm = async ()=>{
        await dispatch(itemCud({ method: 'delete', data: null , id: idToDel }))
        setShowAlert(false)
        setIdToDel(null)
        fetchData();
    }

    useEffect(() => {
        fetchData();
    },[search]);

    return (
        <Box>
            {
                loading && <Loading></Loading>
            }
            <AlertDialog
                toggle={showAlert}
                setToggle={setShowAlert}
                cancel={handleCancel}
                confrim={handleConfirm}
                title={"Are you sure?"}
                content={"You want to delete this item."}
            ></AlertDialog>
            <CreateNewStock open={open} setOpen={setOpen} />
            <UpdateItem oldData={itemData} open={editOpen} setOpen={setEditOpen}></UpdateItem>
            <TransferStock open={transferOpen} setOpen={setTransferOpen} itemId={idToAdd}></TransferStock>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                px: 4, py: 3
            }}>
                <Button onClick={() => setOpen(true)} variant='contained'>Add New</Button>
                <SearchInput placeholderText={"Search by item name"}></SearchInput>
            </Box>
            <AddStock open={openAddStock} setOpen={setOpenAddStock} idToAdd={idToAdd} />
            <TableContainer sx={{ height: '100%', px: 3 }}>
                <Table sx={{ minWidth: 650 }}>
                    <TableHead>
                        <TableRow>
                            <StyledTableHead align="center">No</StyledTableHead>
                            <StyledTableHead>Name</StyledTableHead>
                            <StyledTableHead>Item Code</StyledTableHead>
                            <StyledTableHead>Category</StyledTableHead>
                            <StyledTableHead>Sale Price</StyledTableHead>
                            <StyledTableHead>Purchase Price</StyledTableHead>
                            <StyledTableHead align='center'>Commission(%)</StyledTableHead>
                            <StyledTableHead>Stock</StyledTableHead>
                            <StyledTableHead sx={{ textAlign: 'center' }}>Actions</StyledTableHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            (stockList && stockList.data && stockList.data.length > 0) ?
                            stockList.data.map((stock, index) => (
                            <TableRow key={index}>
                                <StyledTableData align="center">{((stockList?.meta?.current_page - 1) * stockList?.meta?.per_page)+(index + 1)}</StyledTableData>
                                <StyledTableData>{stock.name}</StyledTableData>
                                <StyledTableData>{stock.code}</StyledTableData>
                                <StyledTableData>{stock.category ? stock.category.name : "No Category"}</StyledTableData>
                                <StyledTableData>{stock.salePrice ? Number(stock.salePrice).toLocaleString() : "...."}</StyledTableData>
                                <StyledTableData>{stock.purchasePrice ? Number(stock.purchasePrice).toLocaleString() : "...."}</StyledTableData>
                                <StyledTableData align='center'>{stock.commissionPercent ? stock.commissionPercent : "0" }%</StyledTableData>
                                <StyledTableData>{stock.stock}</StyledTableData>
                                <StyledTableData sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                                    {
                                        Number(stock.stock) > 0 &&
                                        <Tooltip title="Stock Transfer">
                                            <IconButton sx={{ mr: 2 }} onClick={() =>{
                                                setTransferOpen(true)
                                                setIdToAdd(stock.id)
                                            }}><MoveUpIcon sx={{ color: theme.palette.info.main }} />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                    <Tooltip title="Update Stock">
                                        <IconButton sx={{ mr: 2 }} onClick={() =>{
                                            setOpenAddStock(true)
                                            setIdToAdd(stock.id)
                                        }}><InventoryIcon sx={{ color: theme.palette.success.main }} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Edit">   
                                    <IconButton sx={{ mr: 2 }} onClick={() =>{
                                        setEditOpen(true)
                                        setItemData(stock)
                                    }}>
                                        <DriveFileRenameOutlineIcon sx={{ color: theme.palette.warning.main }} />
                                    </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete">
                                        <IconButton onClick={()=> handleDelete(stock.id)}>
                                            <DeleteIcon sx={{ color: theme.palette.primary.main }} />
                                        </IconButton>
                                    </Tooltip>
                                </StyledTableData>
                            </TableRow>
                        ))
                        :
                            <TableRow>
                                <TableCell colSpan={9}>
                                    <NoDataAlert content={"There is no item in stocks list"}></NoDataAlert>
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <AppPagination pageCount={stockList?.meta?.last_page}/>
        </Box>
    )
}

export default StockList